const businessProcesses = state => [...state.businessProcesses];
const selectedBusinessProcesses = state => [...state.selectedBusinessProcesses];
const customizedBusinessProcesses = state => [...state.customizedBusinessProcesses];

export default { businessProcesses, selectedBusinessProcesses, customizedBusinessProcesses };
